// Loading skeleton shown while WordDetail is fetching. Mirrors the WordDetail layout to prevent content shift.

/** Placeholder skeleton that mirrors the WordDetail layout while data is loading. */
export function WordDetailSkeleton() {
  return (
    <article className="words-page" aria-busy="true">
      <div className="words-page-header">
        <div
          style={{
            height: 38,
            width: 260,
            borderRadius: 6,
            background: 'var(--color-pms-gray-100)',
          }}
        />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 56px)', gap: 4 }}>
          {(['SGP', 'SPG', 'PSG', 'PGS', 'GPS', 'GSP'] as const).map((code) => (
            <div
              key={code}
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                background: 'var(--color-pms-gray-100)',
              }}
            />
          ))}
        </div>
      </div>
      <div style={{ marginTop: 24, display: 'flex', gap: 8 }}>
        {[80, 100, 130].map((w) => (
          <div
            key={w}
            style={{
              height: 24,
              width: w,
              borderRadius: 999,
              background: 'var(--color-pms-gray-100)',
            }}
          />
        ))}
      </div>
      <div style={{ marginTop: 36, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {[100, 90, 95, 80, 88].map((w) => (
          <div
            key={w}
            style={{
              height: 16,
              width: `${w}%`,
              borderRadius: 4,
              background: 'var(--color-pms-gray-100)',
            }}
          />
        ))}
      </div>
    </article>
  );
}
